import { track } from './tracking/track';
import addStartupScript from './events/addStartupScript';
import addTargetEventListener from './events/addTargetEventListener';
import CourseData from './course_list/course_data';
import './vendor/glider';
import { handleEvent } from './tracking/events';
import setupLazyImages from './media/lazyImage';

const populateCarousel = (target, rawResults) => {
  const glider = new window.Glider(target);
  const div = document.createElement('div');
  rawResults.forEach(course => {
    div.innerHTML = CourseData.render(course, 'card');
    glider.addItem(div.children[0]);
  });
  // if we have a .card element it is the "see more" card, move it to the end
  const moreCard = (target.querySelector('.card'));
  if (moreCard) {
    moreCard.remove();
    glider.addItem(moreCard);
  }
};

const handleSearchComplete = ({detail: { rawResults, targetId }}) => {
  //check to see if we are interested in this event
  if (!targetId) { return; }
  const target = document.getElementById(targetId).querySelector('.glider');
  if (target) {
    if (rawResults.length > 0) {
      populateCarousel(target, rawResults);
      // lazy-load images on cards
      const images = document.querySelectorAll('.image--lazy');
      setupLazyImages(images);
    }
    else {
      // tracking the event where there are no results will allow us to alert on it.
      track('search', {
        target: 'course_search',
        category: 'atlas',
        label: 'results',
        value: 0
      });
    }
  }
};

const gliderConfiguration = {
  'single-slide': {
    slidesToShow: 1,
    scrollLock: true,
    dots: '.glider-dots',
    responsive: [
      {
        breakpoint: 775,
        settings: {
          duration: 2.5,
          draggable: true,
          arrows: {
            prev: '.glider-prev',
            next: '.glider-next'
          },
        }
      }
    ]
  },
  default: {
    slidesToScroll: 'auto',
    itemWidth: 270,
    exactWidth: true,
    responsive: [
      {
        breakpoint: 775,
        settings: {
          slidesToScroll: 3,
          scrollLock: false,
          duration: 2.5,
          draggable: true,
          arrows: {
            prev: '.glider-prev',
            next: '.glider-next'
          },
        }
      }
    ]
  }
};

const setupGlider = (elem) => {
  const variant = elem.dataset.variant || 'default';
  const autoplay = elem.dataset.autoplay;
  const glider = new window.Glider(elem.querySelector('.glider'), gliderConfiguration[variant]);

  if (autoplay) {
    setupGliderAutoplay(glider);
  }
};

function setupGliderAutoplay(glider) {
  const autoplayDelay = 7000;
  const elem = glider.ele;
  let hovering = false;

  let autoplay = setInterval(() => {
    if (!hovering) {
      const nextSlide = glider.slide === glider.slides.length - 1 ? 0 : 'next';
      glider.scrollItem(nextSlide);
    }
  }, autoplayDelay);

  let stopAutoplay = (_event) => {
    clearInterval(autoplay);
    autoplay = null;
    removeEventListeners();
  };

  const controlElements = [glider.ele, glider.arrows?.prev, glider.arrows?.next, ...glider.dots?.children];
  let removeEventListeners = (_event) => {
    controlElements.forEach((el) => {
      el?.removeEventListener('pointerdown', stopAutoplay);
    });
  };

  elem.addEventListener('pointerout', () => { hovering = false; });
  elem.addEventListener('pointerover', () => {  hovering = true; });

  controlElements.forEach((el) => {
    el?.addEventListener('pointerdown', stopAutoplay);
  });
}

export function setup() {
  const elems = Array.from(document.querySelectorAll('.carousel'));

  if (elems) {
    elems.forEach(elem => setupGlider(elem));
  }
}

addStartupScript(setup);
document.addEventListener('searchComplete', handleSearchComplete);
addTargetEventListener('click', '.carousel-link', handleEvent);
